const text = (value) => String(value ?? '').trim();
const lines = (values) => values.map(text).filter(Boolean).join('\n');

export const shipToAddressText = (address = {}) => lines([
  address.ShipToCompanyName, address.ShipToAddress, address.ShipToAddress2,
  [address.ShipToCity, address.ShipToState, address.ShipToZipCode].map(text).filter(Boolean).join(', '),
  address.ShipToCountry,
]);

export const shipToContactText = (address = {}) => lines([
  [address.ShipToFirstName, address.ShipToLastName].map(text).filter(Boolean).join(' '),
  address.ShipToPhone && `Phone: ${address.ShipToPhone}`,
  address.ShipToMobilePhone && `Mobile: ${address.ShipToMobilePhone}`,
  address.ShipToEmail,
]);

export const buildShippingQuoteMailto = (row, formatValue) => {
  const subject = 'Freight quote request';
  const body = [
    'Hello,',
    'Please provide a freight quote for the following shipment:',
    '',
    `Scheduled ship date: ${text(row.CurrentPlanShipDate) ? formatValue(row.CurrentPlanShipDate, 'date') : 'Not provided'}`,
    '',
    `Ship To: ${text(row.ShipToDetails) || 'Not provided'}`,
    '',
    '',
    'Please include availability, transit time, and any additional charges in your quote.',
    'Thank you.',
  ].join('\n').replace(/\r?\n/g, '\r\n');
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
